// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + {"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] + "." + {"440":"24dc0173","581":"444e9c34"}[chunkId] + ".chunk.js");